import { ShiftStatus, ShiftType, CaregiverStatus } from "@/graphql/types";

export const hoursPerShiftOptions = [
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  16,
];

export const siteText = {
  tooltips: {
    shiftStatus: {
      [ShiftStatus.TIMECONFLICT]:
        "This worker has a time conflict associated with this booking.",
      [ShiftStatus.OPEN]:
        "Workers can express interest in this booking and will see it in their mobile app. It is not being actively sent out.",
      [ShiftStatus.SEARCHING]:
        "This shift is actively sending push notifications to care workers who match the location, availability, and worker skills needed for the booking",
      [ShiftStatus.CONFIRMED]:
        "This booking has an assigned worker and the worker has confirmed that they will be there.",
      [ShiftStatus.CANCELLED]:
        "This booking has been cancelled. Workers cannot express interest or clock into a cancelled booking.",
      [ShiftStatus.WORKERCONFIRMATION]:
        "A worker has been assigned to this booking, and the worker must confirm through the mobile app that they will go to the booking before they can clock in.",
      [ShiftStatus.CLOCKEDIN]:
        "The worker assigned to this booking has clocked into their service with the care recipient.",
      [ShiftStatus.CLOCKEDOUT]:
        "The worker assigned to this booking has clocked out, but they have not yet submitted their time card.",
      [ShiftStatus.CONVERTED]:
        "This Open-ended booking has been successfully converted into a timed booking.",
      [ShiftStatus.MISSINGCLOCKOUT]:
        "This booking has reached its scheduled end, but the clocked in worker has yet to clock out.",
      [ShiftStatus.APPROVED]: "Approved",
      [ShiftStatus.MISSED]:
        "The worker assigned to this booking is at least 2 hours late. They may have arrived, but they have not clocked in.",
      [ShiftStatus.LATE]:
        "The worker assigned to this booking is at least 15 minutes late to clocking in.",
      [ShiftStatus.TIMESHEET]:
        "The worker assigned to this booking has finished submitting their timesheet. Please review and approve their timesheet at your earliest opportunity.",
      [ShiftStatus.APPROVED]: "A user has approved this booking’s timesheet",
      [ShiftStatus.PENDING]:
        "This booking has at least 1 worker who has expressed interest in it.",
    },
  },
};

export const STATES = ["ACT", "NSW", "NT", "QLD", "SA", "TAS", "WA", "VIC"];

export const MAX_SHIFT_DURATION = 1440; // 24 hours

// Gql Gen Enum Display Value Overrides & key trimmers
export const ShiftStatusDisplayValues = {
  [ShiftStatus.OPEN]: "Open Not Searching",
  [ShiftStatus.SEARCHING]: "Open Searching",
  [ShiftStatus.PENDING]: "Interested Worker!",
  [ShiftStatus.WORKERCONFIRMATION]: "Worker To Confirm",
  [ShiftStatus.APPROVED]: "Review Complete",
  [ShiftStatus.TIMECONFLICT]: "Time Conflict",
  [ShiftStatus.LATE]: "Late!",
  [ShiftStatus.CLOCKEDIN]: "Clocked In!",
  [ShiftStatus.CLOCKEDOUT]: "Clocked Out",
  [ShiftStatus.TIMESHEET]: "Needs Review!",
  [ShiftStatus.MISSED]: "Missed!",
};

export const ShiftStatusTrimmer = [ShiftStatus.FAILED, ShiftStatus.ONHOLD];

export const normalizedShiftStatus = {
  [ShiftStatus.OPEN]: "Open Not Searching",
  [ShiftStatus.SEARCHING]: "Open Searching",
  [ShiftStatus.PENDING]: "Interested Worker!",
  [ShiftStatus.WORKERCONFIRMATION]: "Worker To Confirm",
  [ShiftStatus.LATE]: "Late!",
  [ShiftStatus.CLOCKEDIN]: "Clocked In!",
  [ShiftStatus.CLOCKEDOUT]: "Clocked Out!",
  [ShiftStatus.TIMESHEET]: "Needs Review!",
  [ShiftStatus.APPROVED]: "Review Complete",
  [ShiftStatus.MISSED]: ShiftStatus.MISSED,
};

export const ShiftTypesDisplayValues = {
  [ShiftType.OPENENDED]: "Open Ended",
  [ShiftType.CLOSEDENDED]: "Timed",
};

export const workersStatusToQuery = [
  CaregiverStatus.ACTIVE,
  CaregiverStatus.INACTIVE,
  CaregiverStatus.PENDING,
];
